<template>
  <div id="pddPrinting-new">
    <div class="">
      <dataSummary :accountList='accountList' :addtionalServiceOpts='addtionalServiceOpts' :sourceOpts="sourceOpts"></dataSummary>
    </div>
  </div>
</template>
<script>
import netAPI from '@/api';
import dataSummary from './components/dataSummary';
import orderCenter from './components/orderCenter';
export default {
  name: 'collectionDataMonitoring',
  components: {
    dataSummary,
    orderCenter
  },
  filters: {},
  data() {
    return {
      activeName: 'chartStatict',
      accountList: [], // 子账号列表
      addtionalServiceOpts: [], // 订单类型
      sourceOpts: [] // 订单来源
    };
  },
  mounted() {
    // 子账号列表
    this.getSubAccount();
    // 订单类型
    this.orderAdditionService();
    // 订单来源
    this.getOrderSource();
  },
  methods: {
    // 获取子账号列表
    getSubAccount() {
      netAPI.getSubAccount().then(res => {
        if (res.success) {
          let list = res.data || [];
          this.accountList = [{userName: '全部', userId: '0'}].concat(list);
        } else {
          this.accountList = [];
        }
      }).catch(() => {
        this.accountList = [];
      });
    },
    // 订单类型
    orderAdditionService() {
      netAPI.orderAdditionService().then(res => {
        if (res.success) {
          this.addtionalServiceOpts = res.data || [];
        } else {
          this.addtionalServiceOpts = [];
        }
      }).catch(() => {
        this.addtionalServiceOpts = [];
      });
    },
    // 订单来源
    getOrderSource() {
      let params = {};
      netAPI.getOrderSource(params).then(res => {
        if (res.success === true) {
          this.sourceOpts = res.data;
          this.sourceOpts.unshift({ name: '全部', code: '', column: '' });
          this.sourceOpts = this.sourceOpts.filter(item => { return (item.column !== 'PDD' && item.code !== '01' && item.code !== '02'&& item.code !== '0'); });
        } else {
          this.$message.error(res.message);
          this.sourceOpts = [];
        }
      }).catch(() => {});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>

</style>
